import React from "react";
import ProductsBody from "./widget/ProductsBody";
import { Col } from "react-bootstrap";
import { HomeContextProvider } from "../../provider/home/HomeContextProvider";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import { HomeGuestUserContextProvider } from "../../provider/home_guest_user/guest_home/HomeGuestUserContextProvider";


const ProductsContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  return (
    <HomeContextProvider>
      <HomeGuestUserContextProvider>
        {type === 3 ? (
          <Col xs={12} xl={10} className="h-100 mx-auto">
            <ProductsBody isModal={isModal} />
          </Col>
        ) : (
          <ProductsBody />
        )}
      </HomeGuestUserContextProvider>
    </HomeContextProvider>
  );
};

export default ProductsContent;
